import { render, staticRenderFns } from "./complainDialog.vue?vue&type=template&id=1f5e742e&scoped=true"
import script from "./complainDialog.vue?vue&type=script&lang=js"
export * from "./complainDialog.vue?vue&type=script&lang=js"
import style0 from "./complainDialog.vue?vue&type=style&index=0&id=1f5e742e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e742e",
  null
  
)

export default component.exports